import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import { MultiLineInput } from "@worthy-npm/clarity";
import PropTypes from "prop-types";
import React from "react";
import Checkbox from "./Checkbox";

const CheckboxGroup = (props) => {
    const {
        question,
        selected,
        onChange,
        showOther,
        onAfterOtherChange,
        isMobile,
        containerClassName,
    } = props;

    return (
        <div className={`${containerClassName} ${isMobile ? "mobile" : ""}`}>
            <span className={"question"}>{question.q}</span>
            <FormControl
                component="fieldset"
                style={{ top: "-60%", fontSize: "16px" }}
            >
                <FormGroup row={!isMobile} className={"choice-container-font"}>
                    {question.answers.map((answer, idx) => {
                        return (
                            <Checkbox
                                key={`label-${answer}-${idx}`}
                                label={answer}
                                checked={selected?.includes(answer) || false}
                                name={answer}
                                onChange={onChange}
                            />
                        );
                    })}
                    {question.other && (
                        <Checkbox
                            key={"label-other"}
                            label={"Other"}
                            name={"other"}
                            checked={selected?.includes("other") || false}
                            onChange={onChange}
                        />
                    )}
                </FormGroup>
            </FormControl>

            {showOther && (
                <div className={"multiline-container"}>
                    <MultiLineInput
                        placeholder={"Feel free to share"}
                        label={null}
                        minRows={question.answers.length > 3 ? 1 : 2}
                        maxRows={question.answers.length > 3 ? 1 : 2}
                        blur={(value) => {
                            onAfterOtherChange(`other: ${value}`);
                        }}
                    />
                </div>
            )}
        </div>
    );
};

CheckboxGroup.propTypes = {
    question: PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.string),
        other: PropTypes.bool,
        q: PropTypes.string,
    }),
    containerClassName: PropTypes.string,
    onChange: PropTypes.func,
    selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    showOther: PropTypes.bool,
    onAfterOtherChange: PropTypes.func,
    isMobile: PropTypes.bool,
};

export default CheckboxGroup;
